import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { displayMoment, displayNow } from '../utils/displayTime';

const Timestamp = ({ timestamp, precise, format, countryCode }) => {
  let time;
  // Convert display values only; date inputs and API serialization keep their default zone.
  const t = displayMoment(timestamp, countryCode);
  const now = displayNow(countryCode);
  const startYear = now.clone().startOf('year');
  const accurateTime = (tMoment, tStart) => {
    const days = now.diff(tMoment, 'days');
    if (days < 2) {
      return tMoment.calendar(now, {
        sameDay: '[Today] hh:mm a',
        lastDay: '[Yesterday] hh:mm a',
        lastWeek: 'DD MMM hh:mm a',
        sameElse: 'DD MMM hh:mm a',
      });
    }
    if (tMoment.isAfter(tStart)) {
      return tMoment.format('DD MMM hh:mm a');
    }
    return tMoment.format('DD/MM/YY hh:mm a');
  };
  const simpleTime = (tMoment, tStart) => {
    if (tMoment.isAfter(tStart)) {
      return tMoment.format('DD MMM');
    }
    return tMoment.format('DD MMM YYYY');
  };
  if (precise) {
    time = accurateTime(t, startYear);
  } else {
    time = simpleTime(t, startYear);
  }
  if (format) {
    time = t.format(format);
  }
  return (
    <span className="timestamp">
      {time}
    </span>
  );
};

Timestamp.propTypes = {
  timestamp: PropTypes.oneOfType([
    PropTypes.string,
  ]),
  precise: PropTypes.bool,
  format: PropTypes.string,
  countryCode: PropTypes.string,
};

export default connect(state => ({
  countryCode: state.auth && state.auth.company && state.auth.company.countryCode,
}))(Timestamp);



// WEBPACK FOOTER //
// ./src/components/Timestamp.jsx